import * as React from 'react';
import { observer } from 'mobx-react';
import { IObservableValue, observable } from 'mobx';
import { BaseQuestionnaire } from '../../../pages/questionnaire/questionnaireTypes';
import QuestionnaireTitlePage from './QuestionnaireTitlePage';
import { ReactNode } from 'react';

interface Props {
  questionnaire: BaseQuestionnaire,
  children: {
    catalogue: ReactNode,
    errorPage: ReactNode
  }
}

@observer
class Questionnaire extends React.Component<Props> {

  private start: IObservableValue<boolean> = observable.box(false);

  constructor(props: Props) {
    super(props)
  }

  public render() {
    const children = this.props.children;
    return (
      <>
        {
          (this.props.questionnaire.id) ?
            <div>
              {
                !this.start.get() ?
                  (
                    <QuestionnaireTitlePage onStartClicked={this.startQuestionnaire}
                                            questionnaire={this.props.questionnaire}/>
                  ) :
                  (
                    <>{children.catalogue}</>
                  )
              }
            </div> :
            <>{children.errorPage}</>
        }
      </>
    )
  }

  private startQuestionnaire = () => {
    this.start.set(true);
  };

}

export default Questionnaire;
